import React from "react";
import { Spinner } from "react-bootstrap";

interface IAbpnSpinnerProps {
    justifyContent ?: "center" | "start"
}

export function AbpnSpinner(props : IAbpnSpinnerProps) {
    const contentJustification = `justify-content-${props.justifyContent || "center" }`
    return <div className={`d-flex ${contentJustification}`}><Spinner animation={"border"}></Spinner></div>;
}

export default AbpnSpinner;
